//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { List } from 'vant'
import { dig } from '@/utils/lodash'
import { isFunction } from '@/utils/validator'
import error from '../../assets/img/error.png'
import CEmpty from '../CEmpty'

export default {
  components: {
    List,
    CEmpty,
  },

  props: {
    apiMethod: { type: Function },

    params: {
      type: Object,
      default: () => ({}),
    },

    dataHook: { type: Function },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    emptyMsg: {
      type: String,
      default: '暂无数据',
    },

    emptyImg: {
      type: String,
      default: error,
    },

    listChange: { type: Function },

    dataPath: {
      type: String,
      default: 'data.list',
    },

    totalPath: {
      type: String,
      default: 'data.total',
    },

    pageSize: {
      type: [
        Number,
        String,
      ],
      default: 20,
    },

    finishedText: {
      type: [String],
      default: '没有更多了',
    },
  },

  data () {
    return {
      innerList: [],
      loading: false,
      finished: false,
      pageNumber: 1,
      hasData: 'none',
    }
  },

  computed: {
    finishedInnerText () {
      return this.hasData === 'no' ? '' : this.finishedText
    },
  },

  methods: {

    async doLoading () {
      this.loading = true

      const { rows, total } = await this.load(this.pageNumber++)

      this.innerList = [
        ...this.innerList,
        ...rows,
      ]

      if (isFunction(this.listChange)) {
        this.innerList = this.listChange(this.innerList)
      }

      this.loading = false

      if (this.innerList.length > 0) {
        this.hasData = 'yes'
      } else {
        this.hasData = 'no'
      }

      if (this.innerList.length >= total) {
        this.finished = true
      }

      this.$emit('finish-load', {
        rows,
        total,
      })
    },

    async load (pageNumber) {
      if (!this.apiMethod) {
        this.finished = true

        return {
          rows: [],
          total: 0,
        }
      }

      const data = await this.apiMethod({
        ...this.params,
        pageSize: this.pageSize,
        pageNumber,
      }, this.methodConfig, this.postMethod)

      const result = dig(data, this.dataPath) || []
      const total = dig(data, this.totalPath) || 0

      if (+data?.code !== 0) {
        this.finished = true
      }

      return {
        rows: this.dataHook ? this.dataHook(result) : result,
        total,
      }
    },

    reload () {
      this.pageNumber = 1
      this.innerList = []

      this.loading = false
      this.finished = false

      this.doLoading()
    },
  },
}
